import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";
import ViolationType from "../../models/ViolationType";

export default function ViolationTypesManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");

    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [violationTypes, setViolationTypes] = useState([]);
    const [filteredTypes, setFilteredTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // جلب البيانات
    const fetchViolationTypes = async () => {
        try {
            const res = await backEnd_request.get("/ViolationTypes");
            console.log(res.data);
            const data = res.data;
            const mapped = data.map(v => new ViolationType(v));

            setViolationTypes(mapped);
            setFilteredTypes(mapped);
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchViolationTypes();
    }, []);

    // البحث
    const handleSearch = (term) => {
        setSearchTerm(term);

        if (!term.trim()) {
            setFilteredTypes(violationTypes);
            return;
        }

        const filtered = violationTypes.filter((v) =>
            v.name?.toLowerCase().includes(term.toLowerCase())
        );

        setFilteredTypes(filtered);
    };

    // حذف نوع الضبط
    const handleDelete = async (id) => {
        if (!window.confirm("هل أنت متأكد من حذف هذا النوع؟")) return;

        try {
            await backEnd_request.delete(`/ViolationTypes/${id}`);
            fetchViolationTypes();
            setDeleteSuccessMessage("تم حذف نوع الضبط بنجاح ✅");

            setTimeout(() => setDeleteSuccessMessage(""), 3000);
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    return (
        <div className="container py-5">

            {/* العنوان + زر الإضافة */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة أنواع الضبوط</h3>

                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/violation-types/create")}
                >
                    <i className="bi bi-plus-circle"></i> إضافة نوع ضبط
                </button>
            </div>

            {/* رسائل النجاح */}
            {successMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {successMessage}
                </div>
            )}

            {deleteSuccessMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {deleteSuccessMessage}
                </div>
            )}

            {/* أدوات البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>

                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredTypes(violationTypes);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th style={{ minWidth: "200px" }}>اسم نوع الضبط</th>
                            <th style={{ minWidth: "100px" }}>الحالة</th>
                            <th style={{ minWidth: "120px" }}>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTypes.length > 0 ? (
                            filteredTypes.map((vt) => (
                                <tr key={vt.violationTypeId}>
                                    <td>{vt.name}</td>

                                    <td>
                                        <span
                                            className={`badge ${vt.isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                        >
                                            {vt.isActive ? "نشط" : "غير نشط"}
                                        </span>
                                    </td>

                                    <td>
                                        <button
                                            className="btn btn-sm btn-info text-white"
                                            title="عرض الضبوط لهذا النوع"
                                            onClick={() => navigate(`/admin/violations?violationTypeId=${vt.violationTypeId}`)}                                        >
                                            <i className="bi bi-list-check"></i> عرض الضبوط
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() =>
                                                navigate(`/admin/violation-types/edit/${vt.violationTypeId}`)
                                            }
                                        >
                                            تعديل
                                        </button>

                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleDelete(vt.violationTypeId)}
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
